import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMyspaceComponent } from './simple-icons-myspace.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMyspaceComponent ],
    exports:      [ SimpleIconsMyspaceComponent ],
    bootstrap:    []
})
export class SimpleIconsMyspaceModule {}
